'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Promise = require('bluebird');
Promise.config({ cancellation: true });

var _request = require('superagent');
var xml2js = require('xml2js-es6-promise');

var assign = require('lodash/fp/assign');
var isArray = require('lodash/fp/isArray');
var isPlainObject = require('lodash/fp/isPlainObject');

var messages = require('./constants/messages');

/**
 * PictionJS is a JS library that provides methods for accessing Piction's web services.
 *
 * For data that is returned, it provides helper methods and a wrapper around the response data so that property names are more clear and consistent.
 */

var PictionJS = function () {

    /**
     *
     * @param {string} pictionURL e.g. http://dev.piction.com/piction/
     * @param {object} options Options
     * @param {string} options.index Index (AKA download suffix, derivative number) of the original derivative to use for video web quality
     */
    function PictionJS(pictionURL, options) {
        _classCallCheck(this, PictionJS);

        if (!pictionURL || typeof pictionURL !== 'string') {
            throw new Error(messages.errors.PICTIONJS_INVALID_INIT_DATA);
        }

        this._config = assign({
            videoOriginalIndexForWeb: '2', // the default original that should be used for video web quality
            audioOriginalIndexForWeb: '1' // the default original that should be used for audio web quality
        }, options || {}); // override defaults if received in options

        this.hostURL = pictionURL + (pictionURL[pictionURL.length - 1] !== '/' ? '/' : '');
        this.xmlURL = this.hostURL + '!soap.ajaxget';
        this.jsonURL = this.hostURL + '!soap.jsonget';
        this.language;
        this.session = {
            _isSurlCookie: false,
            _surl: null,
            _token: null,
            get surl() {
                return this._surl;
            },
            get token() {
                return this._token;
            },
            get surlCookie() {
                return this._isSurlCookie;
            }
        };
    }

    _createClass(PictionJS, [{
        key: 'setLanguage',
        value: function setLanguage(lang) {
            this.language = lang;
        }
    }, {
        key: 'setDerivatives',
        value: function setDerivatives(options) {
            if (options && options.vidDeriv) this._config.videoOriginalIndexForWeb = options.vidDeriv;
            if (options && options.audDeriv) this._config.audioOriginalIndexForWeb = options.audDeriv;
        }
    }, {
        key: 'addToLightbox',
        value: function addToLightbox(lightboxID, umoIDList, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!lightboxID || !umoIDList || !isArray(umoIDList)) {
                return Promise.reject(new Error(messages.errors.LIGHTBOX_ADD_INVALID_ARGS));
            }

            var data = assign({}, callData || {});

            // used for excluding specific umos when working with a search
            var UMO_ID_KEY = data.SEARCH ? 'EXCLUDE_UMO_ID' : 'UMO_ID';

            var dataAsArray = [['CATEGORY_ID', lightboxID], ['RETURN_UMOIDS', 'T']].concat(_toConsumableArray(umoIDList.map(function (umoID) {
                return [UMO_ID_KEY, umoID];
            })));

            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    dataAsArray.push([key, data[key]]);
                }
            }

            return this.request('Add_To_Lightbox', dataAsArray, { useJSON: true }).then(function (res) {
                if (!res || res.pk === '-1' || res.s.s !== 'T') {
                    var err = new Error(res.s.m);
                    // a little bit of a hack to return the raw response data along with the error
                    err.data = res;
                    throw err;
                }

                return { lightboxID: lightboxID, umoIDList: umoIDList, res: res };
            });
        }
    }, {
        key: 'createLightbox',
        value: function createLightbox(lightboxName, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!lightboxName) {
                return Promise.reject(new Error(messages.errors.LIGHTBOX_CREATE_INVALID_ARGS));
            }

            var data = assign({
                NAME: lightboxName,
                ACCESS: 'PRIVATE',
                PARENTID: '0',
                CREATE_ROLE: 'TRUE',
                MAP_ROLE: 'TRUE'
            }, callData || {});

            return this.request('Lightbox_Create', data, { useJSON: true }).then(function (res) {
                if (res && (res.pk && res.pk !== '-1' || res.s && res.s.s === 'T')) return { name: lightboxName, id: res.pk, res: res };else throw new Error(res.RETURN_MESSAGE || res);
            });
        }
    }, {
        key: 'deleteAllFromLightbox',
        value: function deleteAllFromLightbox(lightboxID, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!lightboxID) {
                return Promise.reject(new Error(messages.errors.LIGHTBOX_DELETE_ALL_FROM_INVALID_ARGS));
            }

            var data = assign({
                CATEGORY_ID: lightboxID
            }, callData || {});

            return this.request('Delete_From_Lightbox_All', data, { useJSON: true }).then(function (res) {
                if (!res || res.s.s !== 'T') {
                    var err = new Error(res.s.m);
                    // a little bit of a hack to return the raw response data along with the error
                    err.data = res;
                    throw err;
                }
                return { lightboxID: lightboxID, umoIDList: [].concat(_toConsumableArray(res.rs), _toConsumableArray(res.re)), res: res };
            });
        }
    }, {
        key: 'deleteFromLightbox',
        value: function deleteFromLightbox(lightboxID, umoIDList, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!lightboxID || !umoIDList || !isArray(umoIDList)) {
                return Promise.reject(new Error(messages.errors.LIGHTBOX_DELETE_FROM_INVALID_ARGS));
            }

            var data = assign({}, callData || {});

            // exclude ids on the list, if a search is performed
            var UMO_ID_KEY = data.SEARCH ? 'EXCLUDE_UMO_ID' : 'UMO_ID';

            var dataAsArray = [['CATEGORY_ID', lightboxID], ['RETURN_UMOIDS', 'T']].concat(_toConsumableArray(umoIDList.map(function (umoID) {
                return [UMO_ID_KEY, umoID];
            })));

            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    dataAsArray.push([key, data[key]]);
                }
            }

            return this.request('Delete_From_Lightbox', dataAsArray, { useJSON: true }).then(function (res) {
                if (!res || res.pk === '-1' || res.s.s !== 'T') {
                    var err = new Error(res.s.m);
                    // a little bit of a hack to return the raw response data along with the error
                    err.data = res;
                    throw err;
                }

                return { lightboxID: lightboxID, umoIDList: umoIDList, res: res };
            });
        }
    }, {
        key: 'editLightbox',
        value: function editLightbox(lightboxID, callData, callOptions) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!lightboxID || !callData || Object.keys(callData).length < 1) {
                return Promise.reject(new Error(messages.errors.LIGHTBOX_EDIT_INVALID_ARGS));
            }

            var data = assign({
                CATEGORY_ID: lightboxID
            }, callData || {});

            var options = assign({
                useJSON: true
            }, callOptions || {});

            return this.request('Lightbox_Edit', data, options).then(function (res) {
                if (res && res.pk !== -1 && res.s && res.s.s === 'T') {
                    return { id: data.CATEGORY_ID, res: res };
                }
                throw new Error(res);
            });
        }
    }, {
        key: 'deleteLightbox',
        value: function deleteLightbox(lightboxID, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!lightboxID) {
                return Promise.reject(new Error(messages.errors.LIGHTBOX_DELETE_INVALID_ARGS));
            }

            var data = assign({
                CATEGORY_ID: lightboxID
            }, callData || {});

            return this.request('Lightbox_Delete', data, { useJSON: true }).then(function (res) {
                if (!res || res.pk === '-1' || res.s.s !== 'T') {
                    throw new Error(res.s.m);
                }

                return {
                    id: data.CATEGORY_ID,
                    res: res
                };
            });
        }
    }, {
        key: 'moveBetweenLightboxes',
        value: function moveBetweenLightboxes(fromLightboxID, toLightboxID, umoIDList, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!fromLightboxID || !toLightboxID || !umoIDList || !isArray(umoIDList)) {
                return Promise.reject(new Error(messages.errors.LIGHTBOX_MOVE_BETWEEN_INVALID_ARGS));
            }

            var data = assign({}, callData || {});

            // used for excluding specific umos when working with a search
            var UMO_ID_KEY = data.SEARCH ? 'EXCLUDE_UMO_ID' : 'UMO_ID';

            var dataAsArray = [['FROM_LIGHTBOX', fromLightboxID], ['TO_LIGHTBOX', toLightboxID], ['RETURN_UMOIDS', 'T']].concat(_toConsumableArray(umoIDList.map(function (umoID) {
                return [UMO_ID_KEY, umoID];
            })));

            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    dataAsArray.push([key, data[key]]);
                }
            }

            return this.request('Move_Between_Lightboxes', dataAsArray, { useJSON: true }).then(function (res) {
                if (!res || res.SUCCESS !== 'T' && res.s.s !== 'T') {
                    var err = new Error(res.RETURN_MESSAGE);
                    // a little bit of a hack to return the raw response data along with the error
                    err.data = res;
                    throw err;
                }

                return { fromLightboxID: fromLightboxID, toLightboxID: toLightboxID, umoList: umoIDList, res: res };
            });
        }

        /**
         * Retrieves categories using Categories_XML
         * @param {object} options
         * @param {object} callData Override default call data -- see Categories_XML documentation for options
         * @returns {Promise}
         */

    }, {
        key: 'getCategories',
        value: function getCategories(options, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            }

            var config = assign({
                excludeLightboxes: true // at the moment there is no way to exclude lightboxes from being returned, so use this flag to remove them from the response.
            }, options || {});

            var data = assign({
                DEPTH: 1,
                INDICATE_IF_CHILD_CATEGORIES: 'TRUE'
            }, callData || {});

            return this.request('Categories_XML', data, { useJSON: true }).then(function (res) {
                return { categoryList: new PictionJS.CategoryList(res.cl || res.ct, { excludeLightboxes: config.excludeLightboxes }), res: res };
            });
        }
    }, {
        key: 'createCategory',
        value: function createCategory(categoryName, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!categoryName) {
                return Promise.reject(new Error(messages.errors.CATEGORY_CREATE_INVALID_ARGS));
            }

            var data = assign({
                TITLE: categoryName,
                OWNED_BY: 'INHERIT',
                PARENT: '0'
            }, callData || {});

            return this.request('CREATE_CATEGORY', data, {}).then(function (res) {
                if (res.a.RETURN_MESSAGE) {
                    throw new Error(res.a.RETURN_MESSAGE[0]);
                }

                return { id: res.a.NEW_CATEGORY[0], name: categoryName, res: res };
            });
        }
    }, {
        key: 'createRootCategory',
        value: function createRootCategory(categoryName, collectionID, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!categoryName || !collectionID) {
                return Promise.reject(new Error(messages.errors.CATEGORY_ROOT_CREATE_INVALID_ARGS));
            }

            var data = assign({
                ACTION: 'INSERT',
                'CATEGORY.TITLE': categoryName,
                'CATEGORY.PARENT_SCENE': 0,
                'CATEGORY.OWNED_BY': 'COLLECTION',
                'CATEGORY.OWNER_ID': collectionID,
                'INHERIT_ROLES': true
            }, callData || {});

            return this.request('MNG_CATEGORY_V2', data, { useJSON: true }).then(function (res) {
                if (res.INSERTED === '1') {
                    return { id: res.pk, name: categoryName, res: res };
                } else if (res.RETURN_MESSAGE && res.z === 'ERROR') {
                    throw new Error(res.e);
                }
            });
        }
    }, {
        key: 'editCategory',
        value: function editCategory(categoryID, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!categoryID || !callData || Object.keys(callData).length < 1) {
                return Promise.reject(new Error(messages.errors.CATEGORY_EDIT_INVALID_ARGS));
            } else if (!callData.TITLE) {
                return Promise.reject(new Error(messages.errors.CATEGORY_EDIT_REQUIRE_TITLE));
            }

            var data = assign({
                QUERY_ID: categoryID
            }, callData || {});

            return this.request('EDIT_CATEGORY', data, {}).then(function (res) {
                if (!res || !res.a || !res.a.RETURN_MESSAGE || res.a.RETURN_MESSAGE[0] !== 'Title Changed') {
                    throw new Error(res.a.RETURN_MESSAGE[0]);
                }

                return { id: data.QUERY_ID, res: res };
            });
        }
    }, {
        key: 'deleteCategory',
        value: function deleteCategory(categoryID, callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!categoryID) {
                return Promise.reject(new Error(messages.errors.CATEGORY_DELETE_INVALID_ARGS));
            }

            var data = assign({
                QUERY_ID: categoryID
            }, callData || {});

            return this.request('DELETE_CATEGORY', data, {}).then(function (res) {
                if (res.a.RETURN_MESSAGE[0] !== 'Category has been deleted') {
                    throw new Error(res.a.RETURN_MESSAGE[0]);
                }

                return { id: data.QUERY_ID, res: res };
            });
        }
    }, {
        key: 'getCollections',
        value: function getCollections(callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            }

            var data = assign({
                OPTION: 'SCHEMAS'
            }, callData || {});

            return this.request('THESAURUS_SEARCH', data).then(function (res) {
                if (res.a.RETURN_MESSAGE) {
                    throw new Error(res.a.RETURN_MESSAGE[0]);
                }

                return { res: res };
            });
        }

        /**
        * Retrieves lightboxes via getCategories.
        * @param {object} options
        * @param {object} callData Override default call data -- see Categories_XML documentation for options
        * @returns {Promise}
        */

    }, {
        key: 'getLightboxes',
        value: function getLightboxes(options, callData) {
            return this.getCategories(assign({ excludeLightboxes: false }, options), assign({ TYPE: 'L' }, callData));
        }
    }, {
        key: 'getMetatags',
        value: function getMetatags(callData) {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!callData || Object.keys(callData).length < 1) {
                return Promise.reject(new Error(messages.errors.METATAG_INVALID_ARGS));
            }

            var data = assign({
                EXPAND_LIST: 'TRUE'
            }, callData || {});

            return this.request('Metatag', data).then(function (res) {
                if (res.a.RETURN_MESSAGE) {
                    throw new Error(res.a.RETURN_MESSAGE[0]);
                }

                return { res: res };
            });
        }

        /**
         * Retrieves UMOs using Image_query
         * @param {string} searchQuery
         * @param {object} callData Override default call data -- see Image_query documentation for options
         * @returns {Promise.<object>} Resolves to an object with properties "umoList", "queryDetails" for the
         * and "res" for the raw response.
         */

    }, {
        key: 'getUMOs',
        value: function getUMOs(searchQuery, callData) {
            var _this = this;

            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            }

            if (typeof searchQuery !== 'string') {
                throw new Error(new Error(messages.errors.GETUMOS_INVALID_ARGS));
            }

            var data = assign({
                SEARCH: searchQuery,
                METADATA: 'TRUE',
                MAXROWS: 50,
                ORIGINAL_URLS: 'TRUE'
            }, callData || {});

            return this.request('Image_query', data).then(function (res) {
                if (res.a.RETURN_MESSAGE) {
                    throw new Error(res.a.RETURN_MESSAGE[0]);
                }

                // clean up the query details (i.e. a.r.s data) so that the values aren't in arrays
                var cleanedQueryDetails = assign({}, res.a.s[0]);
                for (var i in cleanedQueryDetails) {
                    if (cleanedQueryDetails.hasOwnProperty(i)) {
                        cleanedQueryDetails[i] = cleanedQueryDetails[i][0];
                    }
                }

                return {
                    umoList: new PictionJS.UMOList(res.a.r || [], assign({ hostURL: _this.hostURL }, _this._config)),
                    res: res,
                    queryDetails: cleanedQueryDetails
                };
            }).catch(function (err) {
                throw err;
            });
        }

        /**
         * Moves UMO(s) to a new category
         * @param {string,array} umoIDs
         * @param {string} categoryID
         * @param {object} callData
         * @returns {*}
         */

    }, {
        key: 'moveUMOs',
        value: function moveUMOs(umoIDs, categoryID) {
            var callData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            } else if (!umoIDs || !categoryID) {
                return Promise.reject(new Error(messages.errors.MOVE_UMOS_INVALID_ARGS));
            }

            var umoIDList = isArray(umoIDs) ? umoIDs : [umoIDs];

            // used for excluding specific umos when working with a search
            var UMO_ID_KEY = callData && callData.SEARCH ? 'EXCLUDE_UMO_ID' : 'UMO_ID';

            var dataAsArray = [].concat(_toConsumableArray(umoIDList.map(function (umoID) {
                return [UMO_ID_KEY, umoID];
            })), [['CATEGORY_ID', categoryID], ['ORDER_BY', '0'], ['KEEP_MANUAL_ORDERING', 'TRUE']]);

            // append override data
            for (var key in callData) {
                if (callData.hasOwnProperty(key)) {
                    dataAsArray.push([key, callData[key]]);
                }
            }

            return this.request('MOVE_UMO', dataAsArray).then(function (res) {
                if (res.a.RETURN_MESSAGE) {
                    for (var i = 0; i < res.a.RETURN_MESSAGE.length; i++) {
                        if (res.a.RETURN_MESSAGE[i] !== 'Moved' && res.a.RETURN_MESSAGE[i]['_'] !== 'Moved' && res.a.RETURN_MESSAGE[i] !== 'Copied' && res.a.RETURN_MESSAGE[i]['_'] !== 'Copied') {
                            // if there are more than one "RETURN_MESSAGE"s then give a generic response
                            // if only one, then just return the given error as is
                            if (res.a.RETURN_MESSAGE.length > 1) {
                                throw new Error(messages.errors.MOVE_UMOS_MULTIPLE_ERROR);
                            }
                            // return error message depending on the way it's returned from the server
                            throw new Error(typeof res.a.RETURN_MESSAGE[i] === "string" ? res.a.RETURN_MESSAGE[i] : res.a.RETURN_MESSAGE[i]['_']);
                        }
                    }
                }

                return { res: res };
            });
        }

        /**
         * Retrieves and stores an SURL (if no surl cookie is used) and CSRF token
         * to be used with other methods that make Piction queries -- e.g. .getUMOs
         * @param {string} username
         * @param {string} password
         * @returns {Promise.<object>} Resolves to an object with properties "surl" and "res" for the raw response.
         */

    }, {
        key: 'login',
        value: function login(username, password) {
            var _this2 = this;

            if (!username && !password) {
                return Promise.reject(new Error('No username or password supplied'));
            } else if (!username) {
                return Promise.reject(new Error('No username supplied'));
            } else if (!password) {
                return Promise.reject(new Error('No password supplied'));
            }

            return this.request('Piction_login', {
                username: username,
                password: password,
                show_last_login: true,
                password_info: true,
                profile_info: true
            }).then(function (res) {
                if (res.a.RETURN_MESSAGE) {
                    if (res.a.RETURN_MESSAGE[0] && res.a.RETURN_MESSAGE[0].$ && res.a.RETURN_MESSAGE[0].$.respcode && res.a.RETURN_MESSAGE[0].$.respcode.includes('2FA') && res.a.RETURN_MESSAGE[0].$.SURL) {
                        return { surl: res.a.RETURN_MESSAGE[0].$.SURL, isCodeNeeded: res.a.RETURN_MESSAGE[0].$.respcode, res: res };
                    }
                    throw new Error(res.a.RETURN_MESSAGE[0]);
                } else {
                    _this2.session._isSurlCookie = res.a.COOKIE_ENABLED[0] === 'T' ? res.a.COOKIE_NAME[0] : false;
                    _this2.session._surl = _this2.session._isSurlCookie ? '' : res.a.SURL[0];
                    _this2.session._token = res.a.CSRF[0];
                    return { surl: _this2.session._surl, csrf: _this2.session._token, surlCookie: _this2.session._isSurlCookie, res: res };
                }
            });
        }
    }, {
        key: 'codeLogin',
        value: function codeLogin(surl, code) {
            var _this3 = this;

            if (!surl && !code) {
                return Promise.reject(new Error('No surl or code supplied'));
            } else if (!surl) {
                return Promise.reject(new Error('No surl supplied'));
            } else if (!code) {
                return Promise.reject(new Error('No code supplied'));
            }

            return this.request('Piction_login', {
                code: code,
                show_last_login: true,
                password_info: true,
                profile_info: true
            }, { surl: surl }).then(function (res) {
                if (res.a.RETURN_MESSAGE) {
                    throw new Error(res.a.RETURN_MESSAGE[0]);
                } else {
                    _this3.session._isSurlCookie = res.a.COOKIE_ENABLED[0] === 'T' ? res.a.COOKIE_NAME[0] : false;
                    _this3.session._surl = _this3.session._isSurlCookie ? '' : res.a.SURL[0];
                    _this3.session._token = res.a.CSRF[0];
                    return { surl: _this3.session._surl, csrf: _this3.session._token, surlCookie: _this3.session._isSurlCookie, res: res };
                }
            });
        }

        /**
         * Kills the session/surl+token
         * @returns {Promise}
         */

    }, {
        key: 'logout',
        value: function logout() {
            var _this4 = this;

            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            }
            return this.request('Logout', { surl: this.session._surl || '', csrf: this.session._token }).then(function (res) {
                if (res.a.RETURN_MESSAGE) {
                    if (res.a.RETURN_MESSAGE[0] === 'Disconnected') {
                        _this4.session._surl = undefined;
                        _this4.session._token = undefined;
                        return { res: res };
                    } else {
                        throw new Error(res.a.RETURN_MESSAGE[0]);
                    }
                }
            });
        }

        /*
        * Gets Alerts from the server- exp. does the category list need to refresh
        */

    }, {
        key: 'alert',
        value: function alert() {
            if (!this.session._surl && !this.session._isSurlCookie || !this.session._token) {
                return Promise.reject(new Error(messages.errors.NOT_LOGGED_IN));
            }

            return this.request('alert', { surl: this.session._surl || '', csrf: this.session._token }).then(function (res) {});
        }

        /**
         * Makes a call to Piction
         * @param {string} wsCallName Piction web service name. e.g. Image_query
         * @param {object} callData Can be object or array. Use array to preserve the order. e.g. [['METATAG', 'XX.YY'], ['VALUE', 'my value']]
         * @param {object} callOptions
         * @returns {Promise}
         */

    }, {
        key: 'request',
        value: function request(wsCallName, callData, callOptions) {

            if (wsCallName) {
                var options = Object.assign({
                    surl: this.session._surl,
                    csrf: this.session._token,
                    useJSON: false,
                    // a callback for the on('request') of the call. originally put in so the call could be cancelled, before implementing bluebird cancel
                    onRequest: null,
                    language: this.language
                }, callOptions || {});

                var isJSON = false;
                var processedCallData = void 0;
                var postURL = void 0;

                if (options.useJSON && this.jsonURL) {
                    isJSON = true;
                    postURL = this.jsonURL;
                } else {
                    postURL = this.xmlURL;
                }

                // todo: refactor. they're both kinda doing the same thing
                if (isArray(callData)) {

                    processedCallData = 'n=' + wsCallName;

                    // always attach SURL to call- even if empty- for cookies check on piction side
                    processedCallData += '&SURL=' + (options.surl ? options.surl : '');

                    if (options.csrf) {
                        processedCallData += '&CSRF=' + options.csrf;
                    }

                    if (options.language) {
                        processedCallData += '&LANGUAGE=' + options.language;
                    }

                    processedCallData += '&' + callData.map(function (param) {
                        return param.join('=');
                    }).join('&');
                } else {
                    processedCallData = assign({
                        n: wsCallName
                    }, callData || {});

                    // always attach SURL to call- even if empty- for cookies check on piction side
                    processedCallData.SURL = options.surl || '';

                    if (options.csrf) {
                        processedCallData.CSRF = options.csrf;
                    }

                    if (options.language) {
                        processedCallData.LANGUAGE = options.language;
                    }
                }

                return new Promise(function (resolve, reject, onCancel) {
                    var requestObj = void 0;
                    _request.post(postURL).type('form').send(processedCallData).on('request', function (req) {
                        requestObj = req;
                        options.onRequest && options.onRequest(req);
                    }).end(function (err, res) {
                        if (err) {
                            reject(err);
                        } else {
                            if (res.text.includes('SURL failed')) reject(new Error(res.text));else
                                // todo: refactor this, probably just do the xml conversion here
                                resolve(isJSON ? res.body : res.text);
                        }
                    });

                    onCancel(function () {
                        requestObj.abort();
                    });
                }).then(function (res) {
                    if (!isJSON) {
                        return xml2js(res);
                    }

                    return res;
                });
            } else {
                return Promise.reject(new Error('No web service name provided'));
            }
        }
    }, {
        key: 'validate',
        value: function validate(surl) {
            var surlToValidate = surl || this.session._surl || '';

            return this.request('Validate', {
                SURL: surlToValidate,
                SHOW_DETAILS: 'TRUE',
                PASSWORD_INFO: 'TRUE',
                PROFILE_INFO: 'TRUE'
            }).then(function (res) {
                var response = {
                    res: res,
                    surl: surlToValidate
                };

                if (res.a.RETURN_MESSAGE) {
                    switch (res.a.RETURN_MESSAGE[0]) {
                        case 'SURL does not exist':
                        case 'Not Connected':
                        case 'SURL failed validation':
                            response.isValid = false;
                            break;
                        case 'Connected':
                            response.isValid = true;
                            response.username = res.a.a[0]['_'];
                            break;
                        default:
                            throw new Error(res.a.RETURN_MESSAGE[0]);
                            break;
                    }
                } else {
                    throw new Error(messages.errors.VALIDATE_UNEXPECTED_RESPONSE);
                }

                return response;
            });
        }
    }], [{
        key: 'errorMessages',
        get: function get() {
            return messages.errors;
        }
    }]);

    return PictionJS;
}();

PictionJS.Category = function () {
    /**
     * A wrapper for the raw category data from Categories_XML call.
     * @param {object} categoryData This is the raw category data from Categories_XML call
     */
    function _class(categoryData) {
        _classCallCheck(this, _class);

        // check validity of data
        // category data should at the very least have n and i property
        if (!categoryData || !isPlainObject(categoryData) || !categoryData.hasOwnProperty('n') || !categoryData.hasOwnProperty('i')) {

            throw new Error(messages.errors.CATEGORY_INVALID_INIT_DATA);
        }

        this._data = assign({}, categoryData);
        this._isChildrenRetrieved = false;

        // process child categories
        if (this.hasChildren) {
            if (isArray(categoryData.ct) && categoryData.ct.length > 0) {
                this._isChildrenRetrieved = true;
                this._childList = new PictionJS.CategoryList(categoryData.ct);
            } else {
                this._isChildrenRetrieved = false;
                this._childList = new PictionJS.CategoryList([]);
            }
        } else {
            this._isChildrenRetrieved = true;
            this._childList = new PictionJS.CategoryList([]);
        }

        // delete the child raw data since it'd be a duplication of data
        delete this._data.ct;
    }

    _createClass(_class, [{
        key: 'childList',
        get: function get() {
            return this._childList;
        }
    }, {
        key: 'description',
        get: function get() {
            return this._data.d;
        }
    }, {
        key: 'data',
        get: function get() {
            return this._data;
        }
    }, {
        key: 'id',
        get: function get() {
            return this._data.i;
        }
    }, {
        key: 'isChildrenRetrieved',
        get: function get() {
            return this._isChildrenRetrieved;
        }
    }, {
        key: 'hasChildren',
        get: function get() {
            return this._data.ch === 'TRUE';
        }
    }, {
        key: 'name',
        get: function get() {
            return this._data.n;
        }
    }, {
        key: 'type',
        get: function get() {
            return this._data.t;
        }
    }]);

    return _class;
}();

PictionJS.CategoryList = function () {

    /**
     *
     * @param categoryList This is the raw json array coming from Categories_XML call
     * @param options
     */
    function _class2(categoryList, options) {
        _classCallCheck(this, _class2);

        if (!categoryList || !isArray(categoryList)) {
            throw new Error(messages.errors.CATEGORY_LIST_INVALID_INIT_DATA);
        }

        var config = assign({
            excludeLightboxes: true
        }, options || {});

        this._list = [];

        for (var i = 0; i < categoryList.length; i++) {
            if (!config.excludeLightboxes || categoryList[i] && categoryList[i].t !== 'L' && categoryList[i].t !== 'LX') {
                this._list.push(new PictionJS.Category(categoryList[i]));
            }
        }
    }

    _createClass(_class2, [{
        key: 'all',
        get: function get() {
            return this._list;
        }
    }]);

    return _class2;
}();

PictionJS.Metadata = function () {
    function _class3(metadataData) {
        _classCallCheck(this, _class3);

        if (!metadataData || !isPlainObject(metadataData) || !metadataData.hasOwnProperty('$') || !metadataData['$'].hasOwnProperty('id')) {

            throw new Error(messages.errors.METADATA_INVALID_INIT_DATA);
        }

        this._data = assign({}, metadataData);
        this._fullName = this.category + '.' + this.name;
    }

    _createClass(_class3, [{
        key: 'data',
        get: function get() {
            return this._data;
        }
    }, {
        key: 'category',
        get: function get() {
            return this._data['$']['i'];
        }
    }, {
        key: 'dateCreated',
        get: function get() {
            return this._data['$']['dc'];
        }
    }, {
        key: 'dateUpdated',
        get: function get() {
            return this._data['$']['du'];
        }
    }, {
        key: 'displayName',
        get: function get() {
            return this._data['$']['d'];
        }
    }, {
        key: 'fullName',
        get: function get() {
            return this._fullName;
        }
    }, {
        key: 'id',
        get: function get() {
            return this._data['$']['id'];
        }
    }, {
        key: 'name',
        get: function get() {
            return this._data['$']['c'];
        }
    }, {
        key: 'type',
        get: function get() {
            return this._data['$']['t'];
        }
    }, {
        key: 'value',
        get: function get() {
            return this._data['_'] && this._data['_'];
        }
    }]);

    return _class3;
}();

/**
 * List of Metadata objects
 * @type {{new(*=): {getMetadata: (function(): *), all}}}
 */
PictionJS.MetadataList = function () {
    /**
     *
     * @param metadataListData An array of the raw metadata data from image query -- e.g. <mv c="NAME" i="CATEGORY" ...>
     */
    function _class4(metadataListData) {
        _classCallCheck(this, _class4);

        if (!metadataListData || !isArray(metadataListData)) {
            throw new Error(messages.errors.METADATA_LIST_INVALID_INIT_DATA);
        }

        this._list = metadataListData.map(function (metadataData) {
            return new PictionJS.Metadata(metadataData);
        });
    }

    /**
     * Complete array of Metadata objects
     * @returns {Array|*|e}
     */


    _createClass(_class4, [{
        key: 'getMetadata',


        /**
         * Retrieves a single metadata instance
         * Accepts (category, name), (id) or ("category.name")
         * @returns {*}
         */
        value: function getMetadata() {

            if (arguments.length === 2) {
                for (var i = 0; i < this._list.length; i++) {
                    if (this._list[i].name === arguments[1] && this._list[i].category === arguments[0]) {
                        return this._list[i];
                    }
                }
            } else if (arguments.length === 1) {
                if (arguments[0].indexOf('.') > 0) {
                    // is in format "category.name"
                    for (var _i = 0; _i < this._list.length; _i++) {
                        if (this._list[_i].fullName === arguments[0]) {
                            return this._list[_i];
                        }
                    }
                } else {
                    // search for the id
                    for (var _i2 = 0; _i2 < this._list.length; _i2++) {
                        if (this._list[_i2].id === arguments[0]) {
                            return this._list[_i2];
                        }
                    }
                }
            }

            return null;
        }
    }, {
        key: 'all',
        get: function get() {
            return this._list;
        }
    }]);

    return _class4;
}();

/**
 *
 * @type {{new(*=, *=): {uploadDirectory, thumbnail, data, webQuality, name, id, originalList, metadataList, type}}}
 */
PictionJS.UMO = function () {

    /**
     *
     * @param {object} umoData This should be the contents of the <r> tag returned by Image_query
     * @param options
     */
    function _class5(umoData, options) {
        _classCallCheck(this, _class5);

        if (!umoData || !isPlainObject(umoData) || !umoData.hasOwnProperty('n') || !umoData.hasOwnProperty('id')) {

            throw new Error(messages.errors.UMO_INVALID_INIT_DATA);
        }

        this._config = assign({
            hostURL: '' // this is used to prefix the urls with the piction host
        }, options || {});

        /** @type {object} */
        this._data = assign({}, umoData);

        if (isArray(umoData.m) && umoData.m[0] && isArray(umoData.m[0].mv)) {
            this._metadataList = new PictionJS.MetadataList(umoData.m[0].mv);
        } else {
            this._metadataList = new PictionJS.MetadataList([]);
        }

        if (isArray(umoData.mtb) && umoData.mtb[0] && isArray(umoData.mtb[0].mv)) {
            this._tombstoneMetadataList = new PictionJS.MetadataList(umoData.mtb[0].mv);
        } else {
            this._tombstoneMetadataList = new PictionJS.MetadataList([]);
        }

        if (umoData.od) {
            if (umoData.o) {
                var simpleDerivs = isArray(umoData.o) ? umoData.o : [umoData.o];
                var dynamicDerivs = isArray(umoData.od) ? umoData.od : [umoData.od];
                this._originalList = new PictionJS.UMODerivativeList(simpleDerivs.concat(dynamicDerivs), this._config);
            } else this._originalList = new PictionJS.UMODerivativeList(umoData.od || [], this._config);
        } else {
            this._originalList = new PictionJS.UMODerivativeList(umoData.o || [], this._config);
        }

        this._thumbnailDerivative = umoData.i && umoData.i[0] && new PictionJS.UMODerivative(umoData.i[0], this._config);
        this._webQualityDerivative = umoData.wq && umoData.wq[0] && new PictionJS.UMODerivative(umoData.wq[0], this._config);
    }

    /**
     * The raw data given to initialise this object
     * @returns {Object|null}
     */


    _createClass(_class5, [{
        key: 'data',
        get: function get() {
            return this._data;
        }

        /**
         * UMO ID
         * @returns {string|null}
         */

    }, {
        key: 'id',
        get: function get() {
            return this._data.id[0];
        }

        /**
         *
         * @returns {MetadataList}
         */

    }, {
        key: 'metadataList',
        get: function get() {
            return this._metadataList;
        }

        /**
         * UMO name
         * @returns {string|null}
         */

    }, {
        key: 'name',
        get: function get() {
            return this._data.n[0];
        }

        /**
         *
         * @returns {UMODerivativeList}
         */

    }, {
        key: 'originalList',
        get: function get() {
            return this._originalList;
        }

        /**
         * UMO thumbnail
         * @returns {UMODerivative|null}
         */

    }, {
        key: 'thumbnail',
        get: function get() {
            return this._thumbnailDerivative;
        }

        /**
         *
         * @returns {MetadataList}
         */

    }, {
        key: 'tombstoneMetadataList',
        get: function get() {
            return this._tombstoneMetadataList;
        }

        /**
         * UMO type
         * @returns {string} i.e. VIDEO, PHOTO, DOCUMENT, RELATIONAL, AUDIO
         */

    }, {
        key: 'type',
        get: function get() {
            return this._data.t[0];
        }

        /**
         * The directory where the UMO was loaded from -- i.e. the "original location"
         * @returns {string}
         */

    }, {
        key: 'uploadDirectory',
        get: function get() {
            return this._data.d[0]['_'];
        }

        /**
         * UMO web quality. For videos/audio it will return an original derivative.
         * By default, it will be index 2, but this can be overridden using the "...OriginalIndexForWeb" option when calling
         * PictionJs.getUMOs().
         * @returns {UMODerivative|null}
         */

    }, {
        key: 'webQuality',
        get: function get() {
            // todo: these should default to the values set as the defaults in the PictionJS constructor not hardcoded again
            if (this.type === 'VIDEO') {
                return this.originalList.getDerivative(this._config.videoOriginalIndexForWeb || 2);
            }
            if (this.type === 'AUDIO') {
                return this.originalList.getDerivative(this._config.audioOriginalIndexForWeb || 1);
            }
            return this._webQualityDerivative;
        }
    }]);

    return _class5;
}();

PictionJS.UMODerivative = function () {

    /**
     *
     * @param umoDerivativeData is the JSON converted data of, for example, <o u="ump...." o="1"/>
     * It can also be either the wq or i tag.
     * @param options
     */
    function _class6(umoDerivativeData) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, _class6);

        if (!umoDerivativeData || !isPlainObject(umoDerivativeData) || !umoDerivativeData.hasOwnProperty('$') || !(umoDerivativeData['$'].hasOwnProperty('u') || umoDerivativeData['$'].hasOwnProperty('thumbnail'))) {

            throw new Error(messages.errors.UMO_DERIVATIVE_INVALID_INIT_DATA);
        }

        this._data = assign({}, umoDerivativeData);

        if (this.type === 'HTML') {
            this._url = this._data['$']['h'];
        } else {
            this._url = this._data['$']['u'] || this._data['$']['thumbnail'];
        }

        if (options.hostURL) {
            // for Web Delivery Server urls- remove the /piction/ from the hostURL
            var host = this._url.includes('/wds/') ? options.hostURL.substr(0, options.hostURL.length - 9) : options.hostURL;
            this._url = host + this._url;
        }
    }

    /**
     * AKA primary key. Maps to the "p" property.
     * @returns {string|null}
     */


    _createClass(_class6, [{
        key: 'id',
        get: function get() {
            return this._data['$']['p'];
        }

        /**
         * AKA primary key. Maps to the "p" property.
         * @returns {string|null}
         */

    }, {
        key: 'index',
        get: function get() {
            return this._data['$']['o'];
        }
    }, {
        key: 'mimeType',
        get: function get() {
            return this._data['$']['mt'];
        }
    }, {
        key: 'name',
        get: function get() {
            return this._data['$']['pn'];
        }
    }, {
        key: 'type',
        get: function get() {
            return this._data['$']['t'];
        }
    }, {
        key: 'url',
        get: function get() {
            return this._url;
        }
    }, {
        key: 'downloadCode',
        get: function get() {
            return this._data['$']['dwlcode'];
        }
    }, {
        key: 'fileName',
        get: function get() {
            return this._data['$']['fn'];
        }
    }]);

    return _class6;
}();

PictionJS.UMODerivativeList = function () {
    /**
     *
     * @param umoDerivativeListData an array of JSON converted data of, for example, <o u="ump...." o="1"/>
     * It can also be either the wq or i tag.
     * @param options
     */
    function _class7(umoDerivativeListData) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, _class7);

        if (!umoDerivativeListData || !isArray(umoDerivativeListData)) {
            throw new Error(messages.errors.UMO_DERIVATIVE_LIST_INVALID_INIT_DATA);
        }

        this._list = umoDerivativeListData.map(function (umoDerivative) {
            return new PictionJS.UMODerivative(umoDerivative, options);
        });
    }

    _createClass(_class7, [{
        key: 'getDerivative',
        value: function getDerivative(derivativeIndex) {
            for (var i = 0; i < this._list.length; i++) {
                if (this._list[i].index === derivativeIndex || this._list[i].index === derivativeIndex.toString()) {
                    return this._list[i];
                }
            }
            return null;
        }
    }, {
        key: 'all',
        get: function get() {
            return this._list;
        }
    }]);

    return _class7;
}();

PictionJS.UMOList = function () {
    function _class8(umoListData) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, _class8);

        if (!umoListData || !isArray(umoListData)) {
            throw new Error(messages.errors.UMO_LIST_INVALID_INIT_DATA);
        }

        this._list = umoListData.map(function (umo) {
            return new PictionJS.UMO(umo, options);
        });
    }

    _createClass(_class8, [{
        key: 'getUMO',
        value: function getUMO(umoID) {
            for (var i = 0; i < this._list.length; i++) {
                if (this._list[i].id === umoID) {
                    return this._list[i];
                }
            }
            return null;
        }
    }, {
        key: 'all',
        get: function get() {
            return this._list;
        }
    }]);

    return _class8;
}();

module.exports = PictionJS;


//////////////////
// WEBPACK FOOTER
// ./~/piction-js/lib/index.js
// module id = 385
// module chunks = 0 1 2 5